module.exports = __webpack_public_path__ + "img/office7_7-8-2021.f379b73f.jpg";